import { Collapse, Stack } from "@mui/material";
import { type FC, type PropsWithChildren, useState } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ShowAllToggleButton } from "web_myplann/Shared/Components/ShowAllToggleButton";
import { hasAnyDetailValue } from "web_myplann/Shared/Utils/hasAnyDetailValue";

const PageResources = Resources.PortfolioDetail.Property;

type Props = {
	noun: "realEstate" | "vehicle";
	values: (string | number | null | undefined)[];
};

export const PropertyExtendedParams: FC<PropsWithChildren<Props>> = ({
	noun,
	values,
	children,
}) => {
	const { t } = useResource();
	const [expanded, setExpanded] = useState(false);

	if (!hasAnyDetailValue(...values)) {
		return null;
	}

	const nounLabel = t(
		noun === "vehicle"
			? PageResources.ParametersNounVehicle
			: PageResources.ParametersNounRealEstate,
	);

	return (
		<Stack>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<Stack>{children}</Stack>
			</Collapse>
			<ShowAllToggleButton
				variant="disclosure"
				expanded={expanded}
				onClick={() => setExpanded((prev) => !prev)}
				collapsedLabel={t(PageResources.ShowParameters, { noun: nounLabel })}
				expandedLabel={t(PageResources.HideParameters, { noun: nounLabel })}
			/>
		</Stack>
	);
};
